/*** IMPORTS FROM imports-loader ***/
var global = window;

export default function getVariation(placement) {
  return placement.split('-')[1];
}
